import {TextArea} from '@smart/react-components';
import React, {useContext} from 'react';
import type {StringSchema} from 'yup';
import type {Maybe} from '../../../graphql';
import {FieldContext} from './field-wrapper';
import {parseFieldErrors} from './helpers';
import type {ICommonFieldProps, IWrapperProvider} from './types';
import {useFieldSetup} from './use-field-setup';

type TextInputProps = React.ComponentProps<typeof TextArea>;

interface IProps extends ICommonFieldProps {
  initial?: string;
  max?: number;
  props?: Partial<TextInputProps>;
  schema?: StringSchema<any>;
  label?: Maybe<string>;
}

const AreaField = function ({
  tag,
  initial = ``,
  max,
  required,
  schema,
  props,
  label,
}: IProps) {
  const {getLabel, genericHandler, disabled, state, errors, showErrors} =
    useContext<IWrapperProvider>(FieldContext as any);

  useFieldSetup(tag, initial, schema);

  const [isInvalid, errorMessage] = parseFieldErrors(tag, errors, showErrors);

  const charCount = state[tag]
    ? `${(state[tag] as string).length}/${max}`
    : `0/${max}`;

  return tag in state ? (
    <TextArea
      label={getLabel(tag, required, label)}
      caption={charCount}
      onChange={(event) => genericHandler(tag, event.target.value)}
      value={state[tag] as string}
      invalid={isInvalid}
      error={errorMessage}
      maxLength={max}
      disabled={disabled}
      {...props}
    />
  ) : null;
};

export default AreaField;
